import { Record } from 'immutable';
const defaults = {
  appId: 0,
  height: 600,
  isReady: true,
  name: '',
  url: '',
  width: 400,
  supportsCustomObjects: false,
  supportsInboundCalling: false,
  supportsChannelConnection: false
};
function getBooleanAttribute(providerAttributes, attributeName) {
  return Boolean(typeof providerAttributes[attributeName] === 'boolean' ? providerAttributes[attributeName] : defaults[attributeName]);
}
class CallingProvider extends Record(defaults, 'CallingProvider') {
  constructor(props) {
    const providerAttributes = props || defaults;
    const appId = providerAttributes.appId || defaults.appId;
    const height = providerAttributes.height || defaults.height;
    const url = providerAttributes.url || defaults.url;
    const width = providerAttributes.width || defaults.width;
    const isReady = getBooleanAttribute(providerAttributes, 'isReady');
    const supportsCustomObjects = getBooleanAttribute(providerAttributes, 'supportsCustomObjects');
    const supportsInboundCalling = getBooleanAttribute(providerAttributes, 'supportsInboundCalling');
    const supportsChannelConnection = getBooleanAttribute(providerAttributes, 'supportsChannelConnection');
    super({
      name: providerAttributes.name,
      appId,
      height,
      isReady,
      supportsCustomObjects,
      supportsInboundCalling,
      supportsChannelConnection,
      url,
      width
    });
  }
}
export default CallingProvider;